import React from 'react';

import  Scintilla2025  from 'views/Scintilla2025';

const BlogNewsroomPage = () => {

return <Scintilla2025/>
};

export default BlogNewsroomPage;